module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/2/1-ea7ce84a6497407b237b3c1971fe5eee.jpg";